export default {
    'gallery': 'Galeria',
    'go-to-date': 'Przejdź do wpisów z dnia {0}',
    'images-counter': '{current} z {entries}',
    'load-more': 'Załaduj więcej',
    'more-blog-posts': 'Więcej wpisów z bloga',
    'more-news': 'Więcej aktualności',
    'newest': 'Najnowsze wpisy',
    'photos-author': 'Zdjęcia: {0}',
    'read-more': 'Czytaj dalej',
    'show-tags': 'Pokaż tagi',
    'similar': 'Podobne wpisy'
}
